import { AloftPrice, AloftPriceJSON, orUndefined } from '@aloft/toolkit-shared';
import { Flex, Typography } from '@aloft/toolkit-sui';

import { FieldPath, useWatch } from 'react-hook-form';

import { PropertyGridForm } from '../types.ts';
import { readOnlyFieldProps, readOnlyFieldTypographyProps } from './styles.ts';
import { PropertyGridFieldProps } from './types.ts';

export const ReadOnlyUnitRateField = ({
  columnIndex,
  field,
  colSpan = 1,
  control,
}: PropertyGridFieldProps) => {
  const { unitRate } = field;

  const unitRateFieldName =
    `columns.${columnIndex}.propertyData.editableData.salesComparison.unitRates.${unitRate?.key}` as FieldPath<PropertyGridForm>;

  const storedUnitRate = useWatch({ control, name: unitRateFieldName }) as
    | AloftPriceJSON
    | undefined;

  if (!unitRate) return <Typography {...readOnlyFieldProps(colSpan)}>-</Typography>;

  const displayRate = orUndefined(AloftPrice.schema.parse)(storedUnitRate);

  return (
    <Flex
      alignItems="center"
      justifyContent="space-between"
      __dangerDoNotUseSx={{
        ...readOnlyFieldProps(colSpan).__dangerDoNotUseSx,
        paddingRight: '6px',
      }}
    >
      <Typography {...readOnlyFieldTypographyProps}>
        {displayRate?.toString(true) ?? '-'}
      </Typography>
      {unitRate.label && displayRate && (
        <Typography
          variant="body2"
          inline
          color="textSecondary"
          __dangerDoNotUseSx={{
            flexShrink: 0,
            lineHeight: 1,
          }}
        >
          {unitRate.label}
        </Typography>
      )}
    </Flex>
  );
};
